import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

type Callback = (id: string, rejectReason?: string) => void;

const useHttpRejectMedicalLeaveRequest = () => {
    const { t } = useTranslation('medicalLeaveRequest');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const rejectMedicalLeaveRequest = (id: string, callback: Callback, rejectReason?: string) => {
        const { exec, abort } = userApi.reject({
            params: { id },
            body: { rejectReason },
            onSuccess: () => {
                toastHandler.push(
                    `success`,
                    t('notifications.rejectMedicalLeaveRequestTitle'),
                    t('notifications.rejectMedicalLeaveRequestSucceededMessage')
                );
                callback(id, rejectReason);
            },
            onError: () => {
                toastHandler.push(
                    `error`,
                    t('notifications.rejectMedicalLeaveRequestTitle'),
                    t('notifications.rejectMedicalLeaveRequestFailedMessage')
                );
            },
        });
        exec();
        return abort;
    };

    return { rejectMedicalLeaveRequest };
};

export default useHttpRejectMedicalLeaveRequest;
